module.exports = __webpack_public_path__ + "img/sliders-03.db8da6f2.svg";